import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@nextui-org/react";
import { useCreate, useUpdate } from "@refinedev/core";
import { useForm } from "@refinedev/react-hook-form";
import React from "react";
import { FormProvider } from "react-hook-form";
import * as yup from "yup";
import { FormInput } from "../../components/ui/form/form-input";
import { useActiveAssociation } from "../../context/active-association.context";
import { useDrawer } from "../../context/drawer.context";
import { apiResources, ResourceIdentifier } from "../../resources";
import { GolfProfessionalLevel } from "../../sdk";

export const UpsertGolfClassForm: React.FC<{
  golfClass?: GolfProfessionalLevel;
}> = ({ golfClass }) => {
  const { closeDrawer } = useDrawer();
  const association = useActiveAssociation();

  const schema = yup.object().shape({
    name: yup.string().required(),
  });

  const form = useForm({
    defaultValues: {
      name: "",
    },
    values: {
      name: golfClass?.name || "",
    },
    resolver: yupResolver(schema),
    refineCoreProps: {
      resource: ResourceIdentifier.GolfProfessionalLevel,
    },
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = form;

  const [loading, setLoading] = React.useState(false);

  const { mutateAsync: updateGolfProfessionalLevel } = useUpdate();
  const { mutateAsync: createGolfProfessionalLevel } = useCreate();

  const onSuccess = () => {
    closeDrawer();
  };

  const onSettled = () => {
    setLoading(false);
  };
  const upsertAssociation = async (data: yup.InferType<typeof schema>) => {
    setLoading(true);
    const upsertArgs = {
      resource: ResourceIdentifier.GolfProfessionalLevel,
      values: {
        ...data,
      },
      successNotification: {
        message: "Golf Professional Level created successfully",
        type: "success" as const,
      },
      errorNotification: (error: any) => {
        console.log("ERROR ", error);
        return {
          message: "Error updating Golf Professional Level",
          description: error?.message,
          type: "error" as const,
          position: "top-center",
        };
      },
    };

    if (!golfClass?.id) {
      createGolfProfessionalLevel(
        {
          ...upsertArgs,
        },
        {
          onSuccess: onSuccess,
          onSettled: onSettled,
        }
      );
    } else {
      await updateGolfProfessionalLevel(
        {
          ...upsertArgs,
          id: golfClass?.id!,
          successNotification: {
            message: "Golf Professional Level updated successfully",
            type: "success" as const,
          },
        },
        {
          onSuccess: onSuccess,
          onSettled: onSettled,
        }
      );
    }
  };
  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(upsertAssociation)}>
        <div className={"grid gap-4 mb-6"}>
          <FormInput
            name={"name"}
            label={"Golf Professional Level"}
            variant={"bordered"}
            control={control}
          />
        </div>
        <Button
          fullWidth
          size={"lg"}
          color={"secondary"}
          type={"submit"}
          isLoading={loading}
          isDisabled={loading}
        >
          Save
        </Button>
      </form>
    </FormProvider>
  );
};
